import { render, staticRenderFns } from "./NotificationsVenue.vue?vue&type=template&id=129935ba&scoped=true"
import script from "./NotificationsVenue.vue?vue&type=script&lang=ts"
export * from "./NotificationsVenue.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsVenue.vue?vue&type=style&index=0&id=129935ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129935ba",
  null
  
)

export default component.exports